export default "__VITE_ASSET__ofQBMkuy__"